export default __webpack_public_path__ + "static/media/editBadge.edcf7e3a.svg";